import {FC, useState} from 'react'
import {useDispatch} from 'react-redux'
import Button from 'jbc-front/components/Button'
import {useMutation} from 'hooks/graphql'
import {ProcedureContext, ReportFormProps} from 'reportForms/ReportForm'
import {asyncError} from 'store/actions/asyncError'
import {
  CHILDCARE_METHOD_SELECT_NAME,
  ChildcareMethod,
  UPDATE_CHILDCARE_METHOD_SELECT,
  UpdateChildcareMethodSelectQueryVariables,
} from './query'
import styles from './ChildcareMethodSelect.scss'

const procedureTmpTypeFromContext = (procedureContext: ProcedureContext): 'draft' | 'employee_draft' =>
  procedureContext === 'admin' ? 'draft' : 'employee_draft'

export const ChildcareMethodSelect: FC<ReportFormProps> = ({
  procedureStatusId,
  submitText,
  afterSubmit,
  procedureContext,
}) => {
  const dispatch = useDispatch()
  const procedureTmpType = procedureTmpTypeFromContext(procedureContext)
  const [isSubmitting, setIsSubmitting] = useState(false)

  const [updateProcedureTmpDatum] = useMutation<unknown, UpdateChildcareMethodSelectQueryVariables>(
    UPDATE_CHILDCARE_METHOD_SELECT
  )

  const handleSelect = (method: ChildcareMethod) => async () => {
    if (isSubmitting) return
    setIsSubmitting(true)
    try {
      await updateProcedureTmpDatum({
        variables: {
          input: {
            procedureStatusId,
            type: procedureTmpType,
            name: CHILDCARE_METHOD_SELECT_NAME,
            data: {method},
          },
        },
      })
    } catch (err) {
      setIsSubmitting(false)
      dispatch(asyncError(err))
      return
    }
    await afterSubmit()
  }

  return (
    <div className="l-wrap-xs">
      <div className="l-title-wrap">
        <h1 className="m-title-main">手続き方法を選択</h1>
      </div>
      <div className={styles.cards}>
        <div className={styles.card}>
          <div className={styles.cardLabel}>新たな手続き情報を入力する</div>
          <div className={styles.cardAction}>
            <Button primary onClick={handleSelect('new')} disabled={isSubmitting}>
              {submitText}
            </Button>
          </div>
        </div>
        <div className={styles.card}>
          <div className={styles.cardLabel}>過去の手続き情報を利用する</div>
          <div className={styles.cardAction}>
            <Button primary onClick={handleSelect('from_past')} disabled={isSubmitting}>
              {submitText}
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
